<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-29 10:21:58
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-07-14 19:57:52
-->
<template>
  <div class="mine-wrapper" v-if="info" :style="{paddingBottom: isMine ? '64px' : 0}">
    <div class="top" >
      <div class="top-info">
        <div class="avatar">
          <van-image
            round
            width="1rem"
            height="1rem"
            :src="info.avatar"
            @click="handleLinkErp(info.erp)"
          />
          <FansPendant v-if="info.id" :userId="info.id"/>
        </div>
        <div class="info">
          <div class="name">
            <span>{{info.erpName}}</span>
            <span></span>
          </div>
          <div class="org" v-if="info.id">
            <span>{{info.delFlag !== 0 ? '(已离职)' : formatOrg(info.department)}}</span>
            <span></span>
          </div>
        </div>
      </div>
      <van-button
        v-if="!isMine"
        @click="handleFollow(info.isFollow)"
        size="small"
        class="attentionBtn"
        :style="{
          background: info.isFollow !== 1 ? info.gender === 1
                              ? '#266bf6'
                              : '#f57575' : '',
          borderColor: info.isFollow !== 1 ? info.gender === 1
                              ? '#266bf6'
                              : '#f57575' : '#d9d9d9',
          color: info.isFollow!== 1 ? '#fff' : '#848484',
        }"
        :icon="info.isFollow !== 1 ? 'like-o' : ''"
        type="default">
        {{info.isFollow === 1 ? '已关注' : '粉Ta'}}
      </van-button>
    </div>
    <div class="fans">
      <div class="fans-item van-hairline--right">
        <div class="value">{{info.likeNum}}</div>
        <div class="label">获赞</div>
      </div>
      <div class="fans-item van-hairline--right">
        <div class="value">{{info.readedNum}}</div>
        <div class="label">被阅读</div>
      </div>
      <div class="fans-item van-hairline--right">
        <div class="value">{{info.collectedNum}}</div>
        <div class="label">被收藏</div>
      </div>
      <div @click="handleLookFans('fans')" class="fans-item van-hairline--right">
        <div class="value">{{info.followerNum}}</div>
        <div class="label">粉丝</div>
      </div>
      <div @click="handleLookFans('attention')" class="fans-item">
        <div class="value">{{info.followingNum}}</div>
        <div class="label">关注</div>
      </div>
    </div>
    <div class="achievement" v-if="info.badgeItems && info.badgeItems.length">
      <div class="title">{{isMine ? '我' : 'Ta'}}的徽章</div>
      <!-- <div class="achievement-item" > -->
        <!-- <img src="../../assets/huizhang.png" class="icon" alt=""> -->
        <div class="badge-list">
          <!-- <span>{{isMine ? '我' : 'Ta'}}的徽章</span> -->
          <div v-for="(item, index) in info.badgeItems" :key="index" class="badge-item">
            <img :src="item.badgeIconUrl"/>
            <span>{{item.level ? `${item.badgeName} Lv${item.level}` : item.badgeName}}</span>
          </div>
        </div>
      <!-- </div> -->
      <!-- <div class="achievement-item">
        <img src="../../assets/chengjiu.png" class="icon" alt="">
        <div>共获得&nbsp;{{info.likeNum}}&nbsp;个点赞&nbsp;·&nbsp;被阅读&nbsp;{{info.readedNum}}&nbsp;人次&nbsp;·&nbsp;被收藏&nbsp;{{info.collectedNum}}&nbsp;人次&nbsp;·&nbsp;发布到外网文章&nbsp;{{info.netPublicNum}}&nbsp;篇</div>
      </div> -->
    </div>
    <div class="article"  v-if="isMine">
      <div class="title">
        我的积分
      </div>
      <div class="sign-icon">
        <!-- <div class="sign-item">
          <span class="integral-icon">Lv.{{level}}</span>
          <div class="label">积分等级</div>
        </div> -->
        <div class="sign-item">
          <span class="integral-icon">{{info.points}}</span>
          <div class="label">总积分</div>
        </div>
        <div class="sign-item">
          <span class="integral-icon">{{info.redeemablePoints}}</span>
          <div class="label">可兑换积分</div>
        </div>
      </div>
    </div>
    <div class="article">
      <div class="title">{{isMine ? '创作中心' : 'Ta的创作'}}</div>
      <div class="article-info">
        <div @click="hanleLookMyArticle('article')" class="article-info-item">
          <img src="../../assets/articleIcon.png" class="icon" alt="">
          <div class="label">文章</div>
        </div>
        <div @click="hanleLookMyArticle('qa')" class="article-info-item">
          <img src="../../assets/aqIcon.png" class="icon" alt="">
          <div class="label">畅聊</div>
        </div>
        <div @click="hanleLookMyColumn()" class="article-info-item">
          <img src="../../assets/column.png" class="icon" alt="">
          <div class="label">专栏</div>
        </div>
        <div  v-if="isMine" @click="hanleLookMyArticle('up')" class="article-info-item">
          <img src="../../assets/upIcon.png" class="icon" alt="">
          <div class="label">点赞</div>
        </div>
        <div  v-if="isMine" @click="hanleLookMyArticle('comment')" class="article-info-item">
          <img src="../../assets/comment.png" class="icon" alt="">
          <div class="label">评论</div>
        </div>
        <div  v-if="isMine" @click="hanleLookMyArticle('collect')" class="article-info-item">
          <img src="../../assets/collectIcon.png" class="icon" alt="">
          <div class="label">收藏</div>
        </div>
        <div  v-if="isMine" @click="hanleLookMyArticle('focus')" class="article-info-item">
          <img src="../../assets/focus.png" class="icon" alt="">
          <div class="label">关注</div>
        </div>
        <div  v-if="isMine" @click="hanleLookMyArticle('viewHistory')" class="article-info-item">
          <img src="../../assets/history.png" class="icon" alt="">
          <div class="label">浏览历史</div>
        </div>
      </div>
    </div>
    <div v-if="bestList.length" class="article best-post-wrap">
      <div class="title">{{isMine ? '我的优创' : 'Ta的优创'}}</div>
      <div
        v-for="item in bestList"
        :key="item.id"
        class="best-post"
        @click="goPostDetail(item)"
      >
        <div class="post-title">
          <img class="post-icon" v-if="item.type === 1" src="../../assets/aqIcon.png"/>
          <img class="post-icon" v-else src="../../assets/articleIcon.png"/>
          <span>{{item.type === 1 ? item.info : item.title}}</span>
        </div>
        <div class="post-info" v-if="item.type !== 1">{{item.info}}</div>
        <div class="post-data">
          <span>{{item.createTime}}</span>
          <span>
            <span style="margin-right: 10px">
              <img style="width: 10px;height:8px;margin-right:2px" src="../../assets/huifu.png"/>
              {{item.totalReplyNum}}
            </span>
            <span>
              <van-icon name="eye-o" />
              {{item.viewNum}}
            </span>
          </span>
        </div>
      </div>
    </div>
    <Footer v-if="isMine" :activeTab="2"/>
  </div>
  <van-loading v-else></van-loading>
</template>

<script>
import Footer from '../../components/footer.vue';
import { Toast } from 'vant';
import { mapActions, mapState } from 'vuex';
import api from '../../api';
import FansPendant from '../../components/fansPendant.vue';

export default {
  components: {
    Footer,
    FansPendant,
  },
  computed: {
    ...mapState(['userInfo']),
    isMine() {
      return !this.$route.query?.id || +this.$route.query?.id === +this.userInfo?.id;
    },
  },
  data() {
    return {
      info: null,
      level: 1,
      bestList: []
    }
  },
  created() {
    this.fetchUserDetail()
    this.fetchUserLevel();
    this.fetchUserBestPostList();
    this.handleBack();
    document.body.scrollTop = document.documentElement.scrollTop = 0
  },
  activated() {
    this.fetchUserDetail()
    this.fetchUserBestPostList();
    this.handleBack()
  },
  methods: {
    ...mapActions(['updateUserInfoList']),
    goPostDetail(postInfo) {
      this.$router.push({
        name: postInfo.type === 1 ? 'bbsDetail' : 'articleDetail',
        params: { id: postInfo.id  }
      })
    },
    handleFollow(isFollow) {
      if (isFollow === 1) {
        api.cancelFollow(this.info.id).then((res) => {
          if (res.code === 200) {
            this.info = {
              ...this.info,
              isFollow: 0,
              followerNum: this.info.followerNum - 1
            }
            Toast.success('取消关注成功')
          }
        })
        return
      }
      api.follow(this.info.id).then((res) => {
        if (res.code === 200) {
          this.info = {
              ...this.info,
              isFollow: 1,
              followerNum: this.info.followerNum + 1
            }
          Toast.success('关注成功')
        }
      })
    },
    handleLinkErp(erp) {
      const options = {
        userId: erp
      }
      window.jme.im.openContactsCard(options);
    },
    handleBack() {
      const _this = this
      let options = {
        disabled: true,
        callback: function() {
          if (window.history.length > 1) {
            _this.$router.go(-1)
          } else {
            _this.$router.replace({ name: 'articleList' })
          }
        }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    fetchUserBestPostList() {
      api.getUserBestPostList(this.$route.query?.id || this.userInfo.id).then(res => {
        const { code, data } = res
        if (code === 200) {
          this.bestList = data;
        }
      })
    },
    fetchUserDetail() {
      this.info = null;
      const params = { id: this.$route.query?.id || this.userInfo.id }
      api.getUserDetail(params).then(res => {
        const { code, data } = res
        if (code === 200) {
          this.info = data;
          this.updateUserInfoList(data.id)
        }
      })
    },
    fetchUserLevel() {
      if (!this.isMine) return;
      api.getUserLevel().then(res => {
        const { code, data: { level } } = res
        if (code === 200) {
          this.level = level.slice(1)
        }
      })
    },
    formatOrg(val) {
      if (val) {
        let ary = val.split('-')
        let filterAry = ary.slice(1, 3)
        return filterAry.join('-')
      }
    },
    handleLookFans(type) {
      if (!this.isMine) return;
      this.$router.push({ name: 'fans', query: { id: this.info.id, type } })
    },
    hanleLookMyArticle(type) {
      this.$router.push({ name: 'myArticle', query: { id: this.info.id, type, userName: this.info.erpName } })
    },
    hanleLookMyColumn() {
      this.$router.push({ name: 'myColumns', query: { id: this.info.id, userName: this.info.erpName} })
    }
  }
}
</script>

<style lang="less" scoped>
.best-post-wrap {
  text-align: left;
}
.best-post {
  margin: 12px 0;
}
.post-data {
  font-size: 12px;
  color: #606266;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.post-title {
  color: #232930;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}
.post-info {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 12px;
  margin-bottom: 4px;
}
.post-icon {
  height: 12px;
  width: 12px;
  margin-right: 4px;
}
.mine-wrapper {
  font-weight: 400;
  font-size: 14px;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px 20px 20px;
    background: #fff;
    
    .top-info {
      position: relative;
      display: flex;
      align-items: center;
    }
    .name {
      color: #232930;
      font-weight: 500;
    }
    .org {
      font-size: 12px;
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
    }
    .info {
      margin-left: 10px;
      color: #606266;
      display: flex;
      flex: 1;
      font-size: 14px;
      flex-direction: column;
      align-items: self-start;
    }
  }
  .fans {
    font-weight: 400;
    font-size: 14px;
    background: #fff;
    display: flex;
    padding: 0px 0px 15px 0;
    .fans-item {
      flex: 1;
      .value {
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
  .label {
    font-size: 12px;
    color: #606266;
  }
  .title {
    text-align: left;
    font-weight: 500;
  }
  .article-info {
    // display: flex;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 15px 0px;
    align-items: center;
    color: #606266;
    padding: 12px 0;
  }
  // .article-info-ta {
  //   display: grid;
  //   grid-template-columns: repeat(4, 1fr);
  //   grid-gap: 15px 0px;
  // }
  .article, .achievement {
    margin: 10px;
    padding: 10px;
    background: #fff;
    border-radius: 4px;
  }
  .article-info-item {
    flex: 1;
  }
  .integral-icon {
    color: #ffa400;
    font-size: 16px;
    font-style: italic;
    font-weight: 700;
    margin-bottom: 5px;
    display: inline-block;
  }
  .sign-icon {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px 0;
    // background: url(../../assets/sign-bg.png) center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .sign-total {
    display: inline-block;
    font-weight: 600;
    margin-top: 15px;
    color: #ffa400;
  }
  .sign-item {
    flex: 1;
  }
  .icon {
    width: 30px;
    height: 30px;
    fill: currentColor;
    overflow: hidden;
  }
  .achievement {
    // text-align: left;
    .icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      margin-right: 8px;
    }
    &-item {
      display: flex;
      margin-top: 8px;
      font-size: 13px;
    }
    .badge-list {
      display: grid;
      // align-items: center;
      grid-template-columns: repeat(4, 1fr);
    }
    .badge-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      // margin-bottom: 10px;
      // margin-left: 16px;
      & > img {
        height: 40px;
        width: 40px;
        object-fit: contain;
      }
      & > span {
        font-size: 10px;
      }
    }
  }
}
.attentionBtn {
  // width: 54px;
  padding: 0 8px;
  height: 20px;
  border-radius: 12px;
  flex-shrink: 0;
}
.attentionFans {
  font-size: 12px;
  color: #606266;
  margin-top: 2px;
}
.avatar {
  position: relative;
}
</style>
